import { computed, ref } from 'vue';

const activeCount = ref(0);
let safetyTimer: number | null = null;
const SAFETY_MS = 30_000;

function clearSafetyTimer() {
  if (safetyTimer !== null) {
    window.clearTimeout(safetyTimer);
    safetyTimer = null;
  }
}

function resetSafetyTimer() {
  clearSafetyTimer();
  safetyTimer = window.setTimeout(() => {
    activeCount.value = 0;
    safetyTimer = null;
  }, SAFETY_MS);
}

/** 静默续期 / 重载媒体期间非阻塞提示（ref-count，可重叠） */
export function beginMediaReconnectHint(): void {
  activeCount.value += 1;
  resetSafetyTimer();
}

export function endMediaReconnectHint(): void {
  if (activeCount.value > 0) {
    activeCount.value -= 1;
  }
  if (activeCount.value === 0) {
    clearSafetyTimer();
  }
}

export const isMediaReconnecting = computed(() => activeCount.value > 0);
